// components/GiftModal.tsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2.tsx';

type GiftModalProps = {
  show: boolean;
  onClose: () => void;
};

const GiftModal: React.FC<GiftModalProps> = ({ show, onClose }) => {
  const [modalStep, setModalStep] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [fade, setFade] = useState(true);
  const { canvaAuthenticated,token } = useCanvaAuth();

  const env = canvaAuthenticated?.env;

  const handleFadeChange = (nextStep: number) => {
    setFade(false);
    setTimeout(() => {
      setModalStep(nextStep);
      setFade(true);
    }, 200);
  };

  const handleClaimGift = async () => {
    if (!token || !env?.claimGiftUrl) return;

    try {
      await fetch(env.claimGiftUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ giftId: canvaAuthenticated?.userProfile?.gift })
      });
      handleFadeChange(2);
    } catch (error) {
      console.error('Failed to claim gift:', error);
      // Optionally handle error state
    }
  };

  const handleSendFeedback = async () => {
    if (!token || !env?.feedbackUrl) return;

    try {
      await fetch(env.feedbackUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ feedback }),
      });
      handleFadeChange(2);
    } catch (error) {
      console.error('Failed to send feedback:', error);
      // Optionally handle error state
    }
  };

  return (
    <Modal show={show} onHide={onClose} contentClassName="gift-modal" centered backdrop="static">
      <div className={`transition-opacity ${fade ? 'opacity-100' : 'opacity-0'} transition duration-300`}>
        <Modal.Header>
          <Modal.Title>
            {modalStep === 0 ? (canvaAuthenticated.env.strings['gift-modal-page-1-title'] || 'gift-modal-page-1-title') :
             modalStep === 2 ? (canvaAuthenticated.env.strings['gift-modal-page-2-title'] || 'gift-modal-page-2-title'):
             (canvaAuthenticated.env.strings['gift-modal-page-3-title'] || 'gift-modal-page-3-title')}
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={onClose} />
        </Modal.Header>

        <Modal.Body>
          {modalStep === 0 && (
            <div className="text-center px-2">
			  <p className="mb-1">{canvaAuthenticated.env.strings['gift-modal-page-1-line-1'] || 'gift-modal-page-1-line-1'}</p>
			  <p className="mb-2">{canvaAuthenticated.env.strings['gift-modal-page-1-line-2'] || 'gift-modal-page-1-line-2'}</p>
			  <p className="mb-4"><strong>{canvaAuthenticated.env.strings['gift-modal-page-1-line-3'] || 'gift-modal-page-1-line-3'}</strong></p>
			  <Button variant="primary" onClick={handleClaimGift}>
				{canvaAuthenticated.env.strings['gift-modal-page-1-btn-claim'] || 'gift-modal-page-1-btn-claim'}
			  </Button>
			</div>
          )}

          {modalStep === 1 && (
            <>
              <div className="text-center px-2 mb-3">
				  <p className="mb-1">{canvaAuthenticated.env.strings['gift-modal-page-2-line-1'] || 'gift-modal-page-2-line-1'}</p>
				  <p className="mb-3">{canvaAuthenticated.env.strings['gift-modal-page-2-line-2'] || 'gift-modal-page-2-line-2'}</p>
				</div>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder={canvaAuthenticated.env.strings['gift-modal-page-2-feedback-input-placeholder'] || 'gift-modal-page-2-feedback-input-placeholder'}
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                  />
                </Form.Group>
                <div className="d-flex justify-content-between">
                  <Button variant="secondary" onClick={onClose}>{canvaAuthenticated.env.strings['btn-cancel'] || 'btn-cancel'}</Button>
                  <Button variant="primary" onClick={handleSendFeedback}>{canvaAuthenticated.env.strings['btn-send'] || 'btn-send'}</Button>
                </div>
              </Form>
            </>
          )}

          {modalStep === 2 && (
            <div className="text-center">
              <p>{canvaAuthenticated.env.strings['gift-modal-page-3-line-1'] || 'gift-modal-page-3-line-1'}</p>
              <Button variant="primary" onClick={onClose}>{canvaAuthenticated.env.strings['btn-close'] || 'btn-close'}</Button>
            </div>
          )}
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default GiftModal;
